module.exports = __webpack_public_path__ + "img/green_057.b72578ff.png";